// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Pr6f","rootParamsCollapsed":"styles_rootParamsCollapsed__1gqmF","rootPreviewFull":"styles_rootPreviewFull__3bUp5","loader":"styles_loader__1wVll"};